import React, { useState } from 'react';
import { useI18nContext } from '@ecg-marktplaats/js-react-i18n';
import { BasicModal, Icon, ListBasic, ListItemBasic, NeutralBadge, Text } from '@hz-design-system/web-ui';
import Classes from './WorkshopServices.scss';
import type { WorkshopServiceApi } from '@ecg-marktplaats/aurora-business-user-profile-api';

const MAX_VISIBLE_SERVICES = 5;

type WorkshopServicesProps = {
  workshopServices: WorkshopServiceApi[];
  allWorkshopServices: WorkshopServiceApi[];
};

const WorkshopServices = ({ workshopServices, allWorkshopServices }: WorkshopServicesProps) => {
  const { t } = useI18nContext();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const hasMore = workshopServices.length > MAX_VISIBLE_SERVICES;
  const visibleServices = workshopServices.slice(0, MAX_VISIBLE_SERVICES);
  const hiddenCount = workshopServices.length - MAX_VISIBLE_SERVICES;
  const selectedServiceNames = new Set(workshopServices.map((s) => s.name));
  const servicesWithDetails = allWorkshopServices.filter((s) => selectedServiceNames.has(s.name));

  return (
    <>
      <div className={Classes.root}>
        <Icon name="car-dealer-services" />
        <div className={Classes.content}>
          <div className={Classes.titleRow}>
            <Text.Regular strong>{t('workshopServices.title')}</Text.Regular>
            <button className={Classes.linkButton} onClick={() => setIsModalOpen(true)}>
              {t('workshopServices.seeAllButton')}
            </button>
          </div>
          <div className={Classes.badges}>
            {visibleServices.map((service) => (
              <NeutralBadge key={service.name}>{t(service.localizationTitleKey)}</NeutralBadge>
            ))}
            {hasMore && (
              <button className={Classes.linkButton} onClick={() => setIsModalOpen(true)}>
                {t('workshopServices.seeNMoreButton', { number: hiddenCount })}
              </button>
            )}
          </div>
        </div>
      </div>

      {isModalOpen && (
        <BasicModal isOpen onClose={() => setIsModalOpen(false)} title={t('workshopServices.modal.title')} size="m">
          <ListBasic className={Classes.servicesList}>
            {servicesWithDetails.map((service) => (
              <ListItemBasic key={service.name}>
                <Text.Regular strong>{t(service.localizationTitleKey)}</Text.Regular>
                <br />
                <Text.Regular>{t(service.localizationDescriptionKey)}</Text.Regular>
              </ListItemBasic>
            ))}
          </ListBasic>
        </BasicModal>
      )}
    </>
  );
};

export default WorkshopServices;
